<template>
  <div>
    <div class="resource-containertwo swiper-container">
      <div class="swiper-wrapper one-wrapper">
         <div class="resource-slide swiper-slide">
          
          <div class="bottom-conternt bottom-conternttwo">
            <a
              class="nectar-post-grid-link"
              target="_blank"
              href="https://aijourn.com/the-power-behind-ai-why-data-quality-matters-more-than-ever/"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img class="bottom-img" src="../assets/2024/05/2025-07-4.png" alt="" />
              <div style="padding: 0px 20px">
                <p class="bigsize">
      The Power Behind AI: Why Data Quality Matters More Than Ever
                </p>
                <span class="meta-date">June 23, 2025</span>
                 <p class="text-overhidden">
       Paul writes an article on the importance of data quality with AI in June, 23. 2025 AI Journal! 
                </p>

                <div class="huisostion">
                  <span class="huibutton huibuttonabsolute"
                    >Company News & Blogs</span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
          <div class="resource-slide swiper-slide">
          
          <div class="bottom-conternt bottom-conternttwo">
            <a
              class="nectar-post-grid-link"
              target="_blank"
              href="https://www.business.com/articles/countries-for-business-process-outsourcing/"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img class="bottom-img" src="../assets/2024/05/2025-07-03.png" alt="" />
              <div style="padding: 0px 20px">
                <p class="bigsize">
         CSI featured in Business.com article; Top Countries for Business Process Outsourcing (and How to Start).
                </p>
                <span class="meta-date">April 29, 2025</span>
                <p class="text-overhidden">
         Paul comments in feature on efficiencies and costs when outsourcing partners worldwide. 
                </p>

                <div class="huisostion">
                  <span class="huibutton huibuttonabsolute"
                    >Company News & Blogs</span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
          <div class="resource-slide swiper-slide">
          
          <div class="bottom-conternt bottom-conternttwo">
            <a
              class="nectar-post-grid-link"
              target="_blank"
              href="https://www.infoworld.com/article/3956251/measuring-success-in-dataops-data-governance-and-data-security.html"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img class="bottom-img" src="../assets/2024/05/2025-7-02-2.png" alt="" />
              <div style="padding: 0px 20px">
                <p class="bigsize">
             CSI featured in InfoWorld article on measuring success in dataops, data governance, and data security.
                </p>
                <span class="meta-date">April 15, 2025</span>
                <p class="text-overhidden">
           CSI is featured in the April 15, 2025 InforWorld article; Measuring success in dataops, data governance, and data security
                </p>

                <div class="huisostion">
                  <span class="huibutton huibuttonabsolute"
                    >Company News & Blogs</span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
         <div class="resource-slide swiper-slide">
          
          <div class="bottom-conternt bottom-conternttwo">
            <a
              class="nectar-post-grid-link"
              target="_blank"
              href="https://www.globalbankingandfinance.com/leveraging-institutional-knowledge-for-better-financial-decisions"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img class="bottom-img" src="../assets/2024/05/2025-07-02-1.png" alt="" />
              <div style="padding: 0px 20px">
                <p class="bigsize">
               Introducing CSI in Global Banking and Finance Review
                </p>
                <span class="meta-date">February 18, 2025</span>
                <p class="text-overhidden">
            Article about CSI and our mandata,  Leveraging Institutional Knowledge for Better Financial Decisions
                </p>

                <div class="huisostion">
                  <span class="huibutton huibuttonabsolute"
                    >Company News & Blogs</span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="resource-slide swiper-slide">
          
          <div class="bottom-conternt bottom-conternttwo">
            <a
              class="nectar-post-grid-link"
              target="_blank"
              href="https://coruzant.com/analytics/revolutionizing-risk-management-business-intelligence-and-analytics/"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img class="bottom-img" src="../assets/2024/05/interview.png" alt="" />
              <div style="padding: 0px 20px">
                <p class="bigsize">
                  Paul opines on global market changes that bring risks to business growth. Data-driven risk management using business intelligence and analytics is crucial for success.
                </p>
                <span class="meta-date">Feb. 6, 2025</span>
                <p class="text-overhidden">
                  Paul's article, "Revolutionizing Risk Management: Busines Intelligence and Analytics"  is featured in Coruzant.com 
                </p>

                <div class="huisostion">
                  <span class="huibutton huibuttonabsolute"
                    >Company News & Blogs</span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="resource-slide swiper-slide">
          
          <div class="bottom-conternt bottom-conternttwo">
            <a
              class="nectar-post-grid-link"
              target="_blank"
              href="https://www.benefitnews.com/opinion/setting-employees-up-with-tech-tools-to-be-successful"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img class="bottom-img" src="../assets/2024/05/ebn.png" alt="" />
              <div style="padding: 0px 20px">
                <p class="bigsize">
                  Paul Boynton provides insight in an article for Emplyee Benefits News titles "Setting Employees Up with the Right Tech Tools to be Successful"
                </p>
                <span class="meta-date">January  07, 2025</span>
                <p class="text-overhidden">
                  Paul's January 7 2025 article with Employee Benefits News, providers of powerful networking,  highly interactive programming and insights not found elsewhere. Employee Benefit News events are the premier destination for the industry’s brightest minds and most influential leaders. 
                </p>

                <div class="huisostion">
                  <span class="huibutton huibuttonabsolute"
                    >Company News & Blogs</span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="resource-slide swiper-slide">
          
          <div class="bottom-conternt bottom-conternttwo">
            <a
              class="nectar-post-grid-link"
              target="_blank"
              href="https://coruzant.com/profiles/paul-boynton/"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img class="bottom-img" src="../assets/2024/05/interview.png" alt="" />
              <div style="padding: 0px 20px">
                <p class="bigsize">
                  Paul is interviewed by Brian Thomas of Coruzant Technologies for the podcast: Revolutionizing Risk Management: Business Intelligence and Analytics
                </p>
                <span class="meta-date">December 14, 2024</span>
                <p class="text-overhidden">
                  Paul is interviewed by Coruzant Technologies, the premiere and largest crowdsourced, digital, technology publication in the world built on Blockchain. Their advisors and contributors come from all over the globe, from Fortune 100 companies, Silicon Valley, and tech startups, just to 
                </p>

                <div class="huisostion">
                  <span class="huibutton huibuttonabsolute"
                    >Company News & Blogs</span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="resource-slide swiper-slide">
          
          <div class="bottom-conternt bottom-conternttwo">
            <a
              class="nectar-post-grid-link"
              target="_blank"
              href="https://canvasrebel.com/meet-paul-boynton/"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img class="bottom-img" src="../assets/2024/05/can.png" alt="" />
              <div style="padding: 0px 20px">
                <p class="bigsize">
                  Paul is interviewed by Canvas Rebel, article “Meet Paul Boynton”.
                </p>
                <span class="meta-date">November 18, 2024</span>
                <p class="text-overhidden">
                  Paul is interviewed by Canvas Rebel Magazine, a publication that features entrepreneurs and leading industry thinkers. 
                </p>

                <div class="huisostion">
                  <span class="huibutton huibuttonabsolute"
                    >Company News & Blogs</span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="resource-slide swiper-slide">
          
          <div class="bottom-conternt bottom-conternttwo">
            <a
            target="_blank"
              class="nectar-post-grid-link"
              href="https://drive.starcio.com/2024/11/gen-ai-innovation-teams-2025/"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img class="bottom-img" src="../assets/2024/05/starcio.png" alt="" />
              <div style="padding: 0px 20px">
                <p class="bigsize">
                  CSI is featured in STARCIO article "What GEN AI Should Tech Innovation Teams Review in 2025?"
                </p>
                <span class="meta-date">November 18, 2024</span>
                <p class="text-overhidden">
                  Commentary by Paul are featured in the STARCIO article featuring many thought leaders in the market.
                </p>

                <div class="huisostion">
                  <span class="huibutton huibuttonabsolute"
                    >Company News & Blogs</span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="resource-slide swiper-slide">
          <div class="bottom-conternt bottom-conternttwo">
            <a
            target="_blank"
              class="nectar-post-grid-link"
              href="https://www.infoworld.com/article/3544514/5-ways-data-scientists-can-prepare-now-for-genai-transformation.html"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img class="bottom-img" src="../assets/2024/05/infoWorld.png" alt="" />
              <div style="padding: 0px 20px">
                <p class="bigsize">
                  Paul Boynton is featured in the Octover 7, 2024 article "5 ways data scientists can prepare now for gen AI transformation"
                </p>
                <span class="meta-date">October 07, 2024</span>
                <p class="text-overhidden">
                  Paul Boynton provides commentary on how data scientists and analysts work, including tools, processes, deliverables and what they can do now to prepare.
                </p>

                <div class="huisostion">
                  <span class="huibutton huibuttonabsolute"
                    >Company News & Blogs</span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="resource-slide swiper-slide">
          <div class="bottom-conternt bottom-conternttwo">
            <a
              class="nectar-post-grid-link"
              target="_blank"
              href="https://www.cio.com/article/3520906/rethinking-enterprise-architects-roles-for-agile-transformation.html"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img class="bottom-img" src="../assets/2024/05/cio.png" alt="" />
              <div style="padding: 0px 20px">
                <p class="bigsize">
                  CSI is featured in CIO.com Sept 17, 2024 article "Rethinking enterprise architects roles for agile transformation".
                </p>
                <span class="meta-date">September 17, 2024</span>
                <p class="text-overhidden">
                  Paul Boynton Co-Founder and COO of CSI is featured in a trending article on why enterprise architects have struggled to deliver business benefits in the digital era and how CIO's can remedy the issue.
                </p>

                <div class="huisostion">
                  <span class="huibutton huibuttonabsolute"
                    >Company News & Blogs</span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="resource-slide swiper-slide">
          <div class="bottom-conternt bottom-conternttwo">
            <a
              class="nectar-post-grid-link"
              target="_blank"
              href="https://valiantceo.com/paul-boynton/"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img class="bottom-img" src="../assets/2024/05/CEo3.png" alt="" />
              <div style="padding: 0px 20px">
                <p class="bigsize">
                  CSI is featured in the August edition of Valiantceo.com with an article on the future of business
                </p>
                <span class="meta-date">August 28, 2024</span>
                <p class="text-overhidden">
                  Paul Boynton Co-Founder and COO of CSI is featured in a trending article about the CSI platform, integrating AI and how AI will impact the Business information industry in the future.
                </p>

                <div class="huisostion">
                  <span class="huibutton huibuttonabsolute"
                    >Company News & Blogs</span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="resource-slide swiper-slide">
          <div class="bottom-conternt bottom-conternttwo">
            <a
              class="nectar-post-grid-link"
              target="_blank"
              href="https://www.cio.com/article/2517449/7-razones-por-las-que-la-analitica-y-el-aprendizaje-automatico-no-cumplen-los-objetivos-empresariales.html"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img class="bottom-img" src="../assets/2024/05/cio.png" alt="" />
              <div style="padding: 0px 20px">
                <p class="bigsize">
                  CSI featured in CIO.com (Spanish): 7 reasons analytics and ML
                  fail to meet business objectives
                </p>
                <span class="meta-date">August 08, 2024</span>
                <p class="text-overhidden">
                  Paul Boynton Co-Founder and COO of CSI is featured in a
                  trending article about Machine Learning in CIO.com.
                </p>

                <div class="huisostion">
                  <span class="huibutton huibuttonabsolute"
                    >Company News & Blogs</span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="resource-slide swiper-slide">
          <div class="bottom-conternt bottom-conternttwo">
            <a
              class="nectar-post-grid-link"
              href="https://www.ictfworld.org/events/EventDetails.aspx?id=1780725&group="
              aria-label="AI can be beneficial for the marketing process"
            >
              <img
                class="bottom-img"
                src="../assets/2024/05/图片4.png"
                alt=""
              />
              <div style="padding: 0px 20px" class="huipostrive">
                <p class="bigsize">
                  CSI Participates in ICTF's Global Credit Professionals
                  Symposium, Las Vegas
                </p>
                <span class="meta-date">April 7-9, 2024</span>
                <p class="text-overhidden">
                  CSI is a sponsor of ICTF, a premier association for executives
                  in international credit, trade and finance...
                </p>
                <div class="huisostion">
                  <span class="huibutton huibuttonabsolute"
                    >Company News & Blogs</span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="resource-slide swiper-slide">
          <div class="bottom-conternt bottom-conternttwo">
            <a
              class="nectar-post-grid-link"
              href="https://www.youtube.com/watch?v=qiIJAW39RdE"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img
                class="bottom-img"
                src="../assets/2024/05/图片1.png"
                alt=""
              />
              <div style="padding: 0px 20px" class="huipostrive">
                <p class="bigsize">CSI Podcast on Deconstructing Data</p>
                <span class="meta-date">July 13, 2024</span>
                <p class="text-overhidden">
                  Paul Boynton of CSI joins BDEX for a podcast on<br />
                  1. Sourcing Data: Obtaining Information Categories<br />
                  2. Enriching Data: Industry ...<br />
                </p>
                <div class="huisostion">
                  <span class="huibutton">Company News & Blogs</span>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="resource-slide swiper-slide">
          <div class="bottom-conternt bottom-conternttwo">
            <a
            target="_blank"
              class="nectar-post-grid-link"
              href="https://financialtechtimes.com/business-decisions-data-solutions-csi/"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img
                class="bottom-img"
                src="../assets/2024/05/图片2.png"
                alt=""
              />
              <div style="padding: 0px 20px" class="huipostrive">
                <p class="bigsize">
                  Article on CSI: Future-Proofing Business Decisions with New
                  Data Solutions from CSI
                </p>
                <span class="meta-date">July, 2024</span>
                <p class="text-overhidden">
                  Financial Tech Times published an article about CSI,
                  Co-Founder Paul Boynton comments ...
                </p>
                <div class="huisostion">
                  <span class="huibutton huibuttonabsolute"
                    >Company News & Blogs</span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="resource-slide swiper-slide">
          <div class="bottom-conternt bottom-conternttwo">
            <a
              class="nectar-post-grid-link"
              href="https://www.infoworld.com/article/2515702/7-reasons-analytics-and-ml-fail-to-meet-business-objectives.html"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img
                class="bottom-img"
                src="../assets/2024/05/图片3.png"
                alt=""
              />
              <div style="padding: 0px 20px" class="huipostrive">
                <p class="bigsize">
                  CSI featured in InfoWorld: 7 reasons analytics and ML fail to
                  meet business objectives
                </p>
                <span class="meta-date">July 15, 2024</span>
                <p class="text-overhidden">
                  Paul Boynton Co-Founder and COO of CSI is featured in a
                  trending article about Machine Learning.
                </p>
                <div class="huisostion">
                  <span class="huibutton">Company News & Blogs</span>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="resource-slide swiper-slide">
          <div class="bottom-conternt bottom-conternttwo">
            <a
            target="_blank"
              class="nectar-post-grid-link"
              href="#applelogin"
              aria-label="AI can be beneficial for the marketing process"
            >
              <img
                class="bottom-img"
                src="../assets/2024/05/截屏2024-08-02 16.38.17.png"
                alt=""
              />
              <div style="padding: 0px 20px">
                <p class="bigsize">
                  CSI launches Apple and Google compatible apps
                </p>
                <span class="meta-date">July 11, 2024</span>
                <p class="text-overhidden">
                  CSI launches mobile apps compatible with Apple IOS and Google
                  Android. These apps provide easy to use functionality for ...
                </p>

                <div class="huisostion">
                  <span class="huibutton huibuttonabsolute"
                    >Company News & Blogs</span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="swiper-button-prev">
        <!-- <i class="el-icon-right"></i> -->
      </div>
      <div class="swiper-button-next">
        <!-- <i class="el-icon-back"></i> -->
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper"; // 注意引入的是Swiper
import "swiper/css/swiper.min.css"; // 注意这里的引入
export default {
  name: "Products",
  props: {
    //  mobel: {
    //     type: Boolean,
    //     default: false,
    //   },
  },
  data() {
    return {
      mobel: false,
      organizationsimgs: [
        {
          title: "Financial Institutions",
          img: require("../assets/2023/10/fpi-300x300.jpg"),
        },
        {
          title: "Insurance",
          img: require("../assets/2023/10/insurance-300x300.jpg"),
        },
        {
          title: "Investment Management",
          img: require("../assets/2023/10/investment-300x300.jpg"),
        },
        {
          title: "Manufacture",
          img: require("../assets/2023/10/manufacture-300x300.jpg"),
        },
        {
          title: "Trade",
          img: require("../assets/2023/10/trade-300x300.jpg"),
        },
        {
          title: "Professional Services",
          img: require("../assets/2023/10/prof-services-300x300.jpg"),
        },
        {
          title: "Ecommerce",
          img: require("../assets/2023/10/ecommerce-300x300.jpg"),
        },
        {
          title: "Data Management",
          img: require("../assets/2023/10/data-management-300x300.jpg"),
        },
        {
          title: "Education",
          img: require("../assets/2023/10/education-300x300.jpg"),
        },
        {
          title: "Organization",
          img: require("../assets/2023/10/organization-300x300.jpg"),
        },
      ],
    };
  },
  watch: {
    "$route.hash": function () {
      // 在这里可以处理hash变化后的逻辑
      // this.scrollToAnchor()
    },
  },
  methods: {
    menuSeen() {
      // 屏幕尺寸
      let screenHeight = document.body.clientWidth;

      if (screenHeight > 1000) {
        this.mobel = false;
        this.getSwiper();
      } else {
        if (screenHeight < 1000) {
          this.mobel = true;
          // if(screenHeight == 1000){
          this.getSwiper();
          // }
        }
      }
    },
    getSwiper() {
      this.swiper = new Swiper(".resource-containertwo", {
        loop: false, // 无缝
        // autoplay: { //自动开始
        //     delay: 3000, //时间间隔
        //     disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        // },
        paginationClickable: true,
        slidesPerView: this.mobel ? 2 : 4, // 一组三个
        spaceBetween: 20, // 间隔
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 窗口变化,重新init,针对F11全屏和放大缩小,必须加
        observer: true,
        observeParents: true,
        // 如果需要分页器
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true, // 分页器可以点击
        // },
      });
    },
  },
  mounted() {
    this.getSwiper();
    window.addEventListener("resize", this.menuSeen);
    this.menuSeen();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.menuSeen);
  },
};
</script>

<style scoped>
.swiper-button-next,
.swiper-button-prev {
  /* right: 10px;
    left: auto; */
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #fff;
  color: black;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 16px;
}
.bottom-conternt {
  position: relative;
  /* width: 24%; */
  background-color: #fff;
  /* font-family: Alegreya Sans; */
  font-size: 18px;
  line-height: 38px;
  padding-bottom: 20px;
  max-width: 330px;
  margin-top: 70px;
  margin-left: 20px;
  margin-bottom: 20px;
  transition: transform 0.42s ease, background-color 0.42s ease;
  overflow: hidden;
}
.bigsize {
  font-size: 28px;
  margin-bottom: 20px;
  display: -webkit-box; /* 使用弹性盒模型 */
  -webkit-box-orient: vertical; /* 垂直方向排列 */
  -webkit-line-clamp: 2; /* 限制为两行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 使用省略号表示超出部分 */
  height: 3em; /* 设置高度以适应两行文本 */
  line-height: 1.5em;
}

.about-box-bottom {
  margin: 0 5%;
  padding-top: 20px;
  padding-bottom: 8%;
}
.bottom-conternt:hover {
  transform: translateY(-4px);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
  /* box-shadow: 0 30px 60px rgba(0, 0, 0, .15); */
}
.bottom-conternt:hover .bottom-img {
  transform: scale(1.1);
}
.bottom-img {
  position: relative;
  width: 102%;
  height: 260px;
  transition: transform 0.42s ease, background-color 0.42s ease;
}
.bigsize {
  font-size: 28px;
  margin-bottom: 20px;
  display: -webkit-box; /* 使用弹性盒模型 */
  -webkit-box-orient: vertical; /* 垂直方向排列 */
  -webkit-line-clamp: 2; /* 限制为两行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 使用省略号表示超出部分 */
  height: 3em; /* 设置高度以适应两行文本 */
  line-height: 1.5em;
}
.text-overhidden {
  overflow: hidden; /* 隐藏超出部分 */
  display: -webkit-box; /* 使用弹性布局 */
  -webkit-box-orient: vertical; /* 垂直方向的布局 */
  -webkit-line-clamp: 3;
}
.meta-date {
  margin-bottom: -20px;
}
a {
  text-decoration: none;
  color: #000000;
}
body {
  font-size: 18px;
}

p {
  font-size: 18px;
}
b {
  font-weight: 400;
}
</style>